var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenu = function SvgIconMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 16 24 .129M4 23l24 .129M4 9l24 .129"
  }))));
};
export { SvgIconMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlLXdpZHRoPSIwIj4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJDdXN0b20tUHJlc2V0IiBzdHJva2U9IiM5Nzk3OTciIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxsaW5lIHgxPSI0IiB5MT0iMTYiIHgyPSIyOCIgeTI9IjE2LjEyODU2MjkiIGlkPSJQYXRoLTIiPjwvbGluZT4KICAgICAgICAgICAgPGxpbmUgeDE9IjQiIHkxPSIyMyIgeDI9IjI4IiB5Mj0iMjMuMTI4NTYyOSIgaWQ9IlBhdGgtMiI+PC9saW5lPgogICAgICAgICAgICA8bGluZSB4MT0iNCIgeTE9IjkiIHgyPSIyOCIgeTI9IjkuMTI4NTYyOTIiIGlkPSJQYXRoLTIiPjwvbGluZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";